/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export const MATERIAL_KEY = {
  NODE_ERROR_RENDER: 'node_error_render',
  NODE_PLACEHOLDER_RENDER: 'node_placeholder_render',
};
